

  import { getUserAuditTrail } from '@appt-digital/frontend-api-lib-sheffmed'
  import React, { useContext, useEffect, useState } from 'react'
  import Paper from '@mui/material/Paper'
  import Typography from '../../../../ui-library/components/Typography'
  import { useFormik } from 'formik'
  import { userSchema } from '../../../../config/validation'
  // import {
  //   deleteAppUser,
  //   editAppUser,
  //   resetAppUser,
  // } from '../../../../handlers/requests/users/appUsersHandler'
  

  import { userUpdate } from '../../../../utils/api'

  import ConfirmationModal from '../../../../ui-library/components/dialogs/ConfirmationModal'
  import { AlertContext } from '../../../../context/AlertContext'
  import TextField from '../../../../ui-library/components/TextField'
  import Dropdown from '../../../../ui-library/components/Dropdown'
  import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
  import Button from '../../../../ui-library/components/Button'
  import Link from '../../../../ui-library/components/Link'
  import { FaUser } from 'react-icons/fa'
  import { MdDeleteForever } from 'react-icons/md'
  import { ThemeContext } from '../../../../ui-library/components/ThemeContext'
  import DashboardContainer from '../../../../ui-library/components/DashboardContainer'
  import TabHeader from '../../../../ui-library/components/TabHeader'
  import { useLocation, useNavigate } from 'react-router-dom'
  import toCapitalised from '../../../../utils/capitaliseString'
  import {
    Table,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
  } from '../../../../ui-library/components/DataTable'
  import uuid from 'react-uuid'
import dayjs from 'dayjs'
  
  function EditUser() {
    const [loading, setLoading] = useState(false)
    const { setAlert } = useContext(AlertContext)
    const [confirmDelete, setConfirmDelete] = useState(false)
    const [confirmReset, setConfirmReset] = useState(false)
    const [audit, setAudit] = useState([])
    const { theme } = useContext(ThemeContext)
    const { state } = useLocation()
    const navigate = useNavigate()
    const initialEdit = {
      ...state?.user
    }
      // ...state?.user,
      // user: state?.user?.user || '',
      // paymentByInvoice: !!state?.user?.paymentByInvoice,
      // priceTier: state?.user?.priceTier || '',
      // shippingTier: state?.user?.shippingTier || ''
    // }
  
    const [priceTier, setPriceTier] = useState(
      {
        label: state?.user?.priceTier,
        value: state?.user?.priceTier,
      } || { label: 'Prices Hidden', value: 'Prices Hidden' }
    )
  
    const [shippingTier, setShippingTier] = useState(
      {
        label: state?.user?.shippingTier,
        value: state?.user?.shippingTier,
      } || { label: 'Default', value: 'Default' }
    )
  
    const [paymentByInvoice, setPaymentByInvoice] = useState(
      {
        label: state?.user?.paymentByInvoice ? 'Yes' : 'No',
        value: !!state?.user?.paymentByInvoice,
      } || { label: 'No', value: false }
    )
  
  
    const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
      useFormik({
        initialValues: initialEdit,
        validationSchema: userSchema,
        onSubmit: async () => await handleEdit(),
      })
    const handleEdit = async () => {

      console.log('state.user', state.user)
      console.log('values', values)


      // return

      await userUpdate(
        state?.user?.id,
        {
          ...values,
          priceTier: priceTier?.label,
          shippingTier: shippingTier?.label,
          paymentByInvoice: paymentByInvoice?.value,
        }
      )
  
      // return
      // setAlert,
      setLoading(false)
      navigate('/dashboard/app')
    }



    // useEffect(() => {
    //   const getAuditTrail = async () => {
    //     const res = await getUserAuditTrail(state?.user?.id)
    //     setAudit(res?.data)
    //   }
    //   getAuditTrail()
    // }, [])
    return (
      <>
        <DashboardContainer>
          <TabHeader
            title={'Edit User'}
            username={
              state?.user?.firstname !== null &&
              state?.user?.firstname !== undefined &&
              state?.user?.lastname !== null &&
              state?.user?.lastname !== undefined &&
              `${toCapitalised(state?.user?.firstname)} ${toCapitalised(
                state?.user?.lastname
              )}`
            }
          >
            <Paper style={theme?.dashboard?.container}>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div>
                  <Link
                    type="submit"
                    onClick={() => {
                      navigate('/dashboard/app')
                    }}
                  >
                    {`< Back`}
                  </Link>
                  <Typography source={'h1'} style={{ marginTop: 20 }}>User Details</Typography>
  
                  <form onSubmit={handleSubmit}>

                    <div
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <Typography source={'h4'} style={{ marginTop: 10 }}>Company Name</Typography>
                      <TextField
                        type="text"
                        name="companyName"
                        value={values.companyName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        errorType={'companyName'}
                        errors={errors}
                        touched={touched}
                      />
                    </div>

                    <div
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <Typography source={'h4'} style={{ marginTop: 10 }}>First Name</Typography>
                      <TextField
                        type="text"
                        name="firstName"
                        value={values.firstName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        errorType={'firstName'}
                        errors={errors}
                        touched={touched}
                      />
                    </div>

                    <div
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <Typography source={'h4'} style={{ marginTop: 10 }}>Last Name</Typography>
                      <TextField
                        type="text"
                        name="lastName"
                        value={values.lastName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        errorType={'lastName'}
                        errors={errors}
                        touched={touched}
                      />
                    </div>

                    <div
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <Typography source={'h4'} style={{ marginTop: 10 }}>Email</Typography>
                      <TextField
                        type="email"
                        name="email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        errorType={'email'}
                        errors={errors}
                        touched={touched}
                      />
                    </div>

                    <div
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <Typography source={'h4'} style={{ marginTop: 10 }}>Mobile</Typography>
                      <TextField
                        type="phone"
                        name="mobile"
                        value={values.mobile}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        errorType={'mobile'}
                        errors={errors}
                        touched={touched}
                      />
                    </div>

                    <div
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <Typography source={'h4'} style={{ marginTop: 10 }}>Invoicing Email</Typography>
                      <TextField
                        type="email"
                        name="invoicingEmail"
                        value={values.invoicingEmail}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        errorType={'invoicingEmail'}
                        errors={errors}
                        touched={touched}
                      />
                    </div>

                    <div
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <Typography source={'h4'} style={{ marginTop: 10 }}>DOB</Typography>
                      <TextField
                        type="date"
                        name="birthdate"
                        value={dayjs(values.birthdate).format('YYYY-MM-DD')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        errorType={'birthdate'}
                        errors={errors}
                        touched={touched}
                      />
                    </div>



                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography source={'h4'} style={{ marginTop: 10 }}>Price Tier</Typography>
                      <Dropdown
                        type="priceTier"
                        id={'priceTier'}
                        name={'priceTier'}
                        setSelected={setPriceTier}
                        onBlur={handleBlur}
                        selected={priceTier}
                        clearable={true}
                        items={[
                          { label: 'Prices Hidden', value: 'Prices Hidden' },
                          { label: 'Tier One', value: 'Tier One' },
                          { label: 'Tier Two', value: 'Tier Two' },
                          { label: 'Tier Three', value: 'Tier Three' }
                        ]}
                        Icon={ArrowDropDownIcon}
                        errorType={'type'}
                        errors={errors}
                        touched={touched}
                        style={{ container: { width: '100%', marginBottom: 5, background: '#fff' } }}
                      />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography source={'h4'} style={{ marginTop: 10 }}>Shipping Tier</Typography>
                      <Dropdown
                        type="shippingTier"
                        id={'shippingTier'}
                        name={'shippingTier'}
                        setSelected={setShippingTier}
                        onBlur={handleBlur}
                        selected={shippingTier}
                         clearable={true}
                        items={[
                          { label: 'Default', value: 'Default' },
                          { label: 'Tier One', value: 'Tier One' },
                          { label: 'Tier Two', value: 'Tier Two' },
                          { label: 'Tier Three', value: 'Tier Three' }
                        ]}
                        Icon={ArrowDropDownIcon}
                        errorType={'type'}
                        errors={errors}
                        touched={touched}
                        style={{ container: { width: '100%', marginBottom: 5, background: '#fff' } }}
                      />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography source={'h4'} style={{ marginTop: 10 }}>Payment By Invoice</Typography>
                      <Dropdown
                        type="paymentByInvoice"
                        id={'paymentByInvoice'}
                        name={'paymentByInvoice'}
                        setSelected={setPaymentByInvoice}
                        onBlur={handleBlur}
                        selected={paymentByInvoice}
                         clearable={true}
                        items={[
                          { label: 'No', value: false },
                          { label: 'Yes', value: true }
                        ]}
                        Icon={ArrowDropDownIcon}
                        errorType={'type'}
                        errors={errors}
                        touched={touched}
                        style={{ container: { width: '100%', marginBottom: 5, background: '#fff' } }}
                      />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
                      <Button type="submit">Save</Button>
                      {/* <Button
                        onClick={() => {
                          setConfirmDelete(true)
                        }}
                        icon={MdDeleteForever}
                        icontype={'endIcon'}
                      >
                        Delete User
                      </Button> */}
                    </div>
                  </form>
                  {/* 
                  <ConfirmationModal
                    onAccept={async () => {
                      await deleteAppUser(state?.user?.id, setAlert)
                      navigate('/dashboard/system')
                    }}
                    isOpen={confirmDelete}
                    onRequestClose={() => setConfirmDelete(false)}
                    type={'Delete'}
                    text={'Are you sure you wish to delete this user?'}
                    icon={MdDeleteForever}
                  /> */}
                
                </div>
                {/* <div
                  style={{
                    margin: 20,
                    borderLeft: '1px solid grey',
                    minHeight: 600,
                  }}
                /> */}
                {/* <div style={{ paddingLeft: 30, paddingRight: 30 }}>
                  <Typography source={'h2'} style={{ marginTop: 30 }}>
                    Audit Trail
                  </Typography>
                  {!audit?.length || audit?.length < 1 ? (
                    <Typography source={'p'} style={{ marginTop: 10 }}>
                      No audit trail found
                    </Typography>
                  ) : (
                    <TableContainer source={'audit'} theme={theme}>
                      <Table source={'audit'} theme={theme}>
                        <TableHead source={'audit'} theme={theme}>
                          {['Time', 'Action']?.map((header, index) => {
                            return (
                              <TableCell
                                source={'audit'}
                                key={uuid()}
                                theme={theme}
                              >
                                <Typography>{header}</Typography>
                              </TableCell>
                            )
                          })}
                        </TableHead>
                        {audit?.map((item) => {
                          return (
                            <TableRow source={'audit'} theme={theme} key={uuid()}>
                              <TableCell source={'audit'} theme={theme}>
                                {new Date(item?.updatedAt).toLocaleString()}
                              </TableCell>
                              <TableCell source={'audit'} theme={theme}>
                                {item?.description}
                              </TableCell>
                            </TableRow>
                          )
                        })}
                      </Table>
                    </TableContainer>
                  )}
                </div> */}
              </div>
            </Paper>
          </TabHeader>
        </DashboardContainer>
      </>
    )
  }
  
  export default EditUser
  